'use client'

import { cn } from '@/core/lib/utils/cn'
import { HeadlineModel } from '@/features/blog/types/models/headline.model'
import { Drawer, DrawerBody, DrawerContent, useDisclosure } from '@heroui/react'
import { HeadlineList } from './list'
import { MenuSquare } from 'lucide-react'

type Props = {
  headlines: HeadlineModel[]
  className?: string
}

export const HeadlineDrawer: React.FC<Props> = ({
  headlines,
  className = '',
}) => {
  const { isOpen, onOpen, onOpenChange } = useDisclosure()

  return (
    <div className={cn(className, 'h-6 w-6')}>
      <button
        onClick={onOpen}
        className='flex items-center justify-center rounded-md border border-gray-200 bg-white p-1.5 shadow-sm transition hover:shadow-md'
      >
        <MenuSquare className='h-5 w-5 text-yellow-600' />
      </button>

      <Drawer
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        radius='md'
        placement='left'
        size='xs'
        classNames={{
          closeButton: 'hidden',
        }}
      >
        <DrawerContent>
          {() => (
            <DrawerBody className='bg-gray-50 p-4'>
              <HeadlineList headlines={headlines} />
            </DrawerBody>
          )}
        </DrawerContent>
      </Drawer>
    </div>
  )
}
